import { OwnerMoleDashInfo } from 'vvs-gotchi-graphql'
import type { Owner } from '../models'

export interface MoleDashInfo {
  todayExp: number
  bestRecord: {
    lasted: number // in ms
    completedAt: Date | null
  }
}

const emptyMoleDashInfo: MoleDashInfo = {
  todayExp: 0,
  bestRecord: {
    lasted: 0,
    completedAt: null,
  },
}

export const moleDashInfoFromGraphqlData = (data: OwnerMoleDashInfo): MoleDashInfo => {
  return {
    todayExp: data?.todayExp ?? 0,
    bestRecord: {
      lasted: data?.bestRecord?.lifespan ?? 0,
      completedAt: data?.bestRecord?.completedAt ? new Date(data.bestRecord.completedAt) : null,
    },
  }
}

export const moleDashInfoFromOwner = (owner: Owner): MoleDashInfo => {
  if (!owner?.moleDashInfo) return emptyMoleDashInfo
  return owner.moleDashInfo
}
